import React from "react";
import { Link } from "react-router-dom";
import useScrollReveal from "../hooks/useScrollReveal";
import Icon from "../components/Icon";

export default function NooraniQaidaPage() {
  useScrollReveal();
  return (
    <>
      <section className="relative overflow-hidden pt-16 pb-20 md:pt-20 md:pb-32 bg-surface-bright">
        <div className="absolute inset-0 geometric-pattern-emerald opacity-40"></div>
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary-fixed opacity-20 blur-3xl rounded-full"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-tertiary-fixed opacity-20 blur-3xl rounded-full"></div>
        <div className="relative page-x max-w-max-width mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-16">
          <div className="flex-1 space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full bg-primary-container text-on-primary-container font-label-md text-label-md">
              <Icon
                name="stars"
                className="material-symbols-outlined text-sm"
              />
              Foundational Program
            </div>
            <h1 className="text-display-responsive text-primary leading-tight">
              Noorani Qaida Program
            </h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant max-w-xl">
              Build a strong, authentic foundation in Arabic letters and
              phonics. Our expertly guided sessions help you master the building
              blocks of Quranic recitation with precision and ease.
            </p>
            <div className="flex flex-col xs:flex-row flex-wrap gap-3 sm:gap-4 pt-4">
              <Link
                to="/contact"
                className="inline-block bg-primary text-on-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full w-full sm:w-auto text-center font-headline-md text-headline-md shadow-lg shadow-primary/20 hover:scale-105 active:scale-95 transition-all"
              >
                Start Free Trial
              </Link>
              <button className="flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-full w-full sm:w-auto text-center font-headline-md text-headline-md border-2 border-primary text-primary hover:bg-surface-container transition-all">
                <Icon
                  name="play_circle"
                  className="material-symbols-outlined"
                />
                Watch Preview
              </button>
            </div>
          </div>
          <div className="flex-1 relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 md:border-8 border-white">
              <img
                alt="Student learning Noorani Qaida"
                className="w-full h-auto object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuDH-k3u9U3xiOxebRF-bJXIcoyhiFLVl3CXIGuKbtrw7ABtQ8BwR8DRyhoxDsMqaXCIlkQ5BW252an7aXx7nV-gkthOJJz0_cJrMsfeK8GjsNLAwRocmxNKYmyp70k0s9h1_ngalSKEdKlUxSX18pTnbcko37Q_Iy7LSpiFwGSWSZbl_K79w7SVhNyhQzIZ1NOcryQiFE0-Cd_BYaDwP_CyZq-mcIZMbkUQzTRh0nR-is2hPww5LjTLrZOmB7zCEbtUc8P2FQXWV1Ji"
              />
            </div>
            <div className="relative md:absolute md:-bottom-8 md:-left-8 mt-6 md:mt-0 bg-white p-4 sm:p-6 rounded-2xl shadow-xl border border-outline-variant flex items-center gap-4 max-w-[calc(100vw-2rem)] md:max-w-none md:animate-bounce">
              <div className="bg-tertiary-container p-3 rounded-full">
                <Icon
                  name="emoji_events"
                  className="material-symbols-outlined text-on-tertiary-container"
                  filled
                />
              </div>
              <div>
                <p className="font-label-md text-label-md text-on-surface-variant">
                  Success Rate
                </p>
                <p className="font-headline-md text-headline-md text-primary">
                  98% Mastery
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-white">
        <div className="page-x max-w-max-width mx-auto">
          <div className="text-center mb-10 md:mb-16 space-y-4">
            <h2 className="text-headline-responsive text-primary">
              Expected Outcomes
            </h2>
            <p className="font-body-md text-body-md text-on-surface-variant max-w-2xl mx-auto">
              By the end of this program, you or your child will be fully
              equipped to transition into complete Quran reading with
              confidence.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-gutter">
            <div className="group card-pad rounded-2xl border border-outline-variant hover:border-primary hover:shadow-xl transition-all duration-300 scroll-reveal">
              <div className="w-16 h-16 bg-surface-container rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-container transition-colors">
                <Icon
                  name="abc"
                  className="material-symbols-outlined text-primary text-3xl group-hover:text-on-primary-container"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-on-surface mb-3">
                Recognize Letters
              </h3>
              <p className="font-body-md text-body-md text-on-surface-variant">
                Master the Arabic alphabet in all their forms: isolated,
                beginning, middle, and end.
              </p>
            </div>

            <div className="group card-pad rounded-2xl border border-outline-variant hover:border-primary hover:shadow-xl transition-all duration-300 scroll-reveal">
              <div className="w-16 h-16 bg-surface-container rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-container transition-colors">
                <Icon
                  name="link"
                  className="material-symbols-outlined text-primary text-3xl group-hover:text-on-primary-container"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-on-surface mb-3">
                Read Joined Letters
              </h3>
              <p className="font-body-md text-body-md text-on-surface-variant">
                Learn how to blend sounds and read connected letters to form
                proper Arabic words.
              </p>
            </div>

            <div className="group card-pad rounded-2xl border border-outline-variant hover:border-primary hover:shadow-xl transition-all duration-300 scroll-reveal">
              <div className="w-16 h-16 bg-surface-container rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-container transition-colors">
                <Icon
                  name="record_voice_over"
                  className="material-symbols-outlined text-primary text-3xl group-hover:text-on-primary-container"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-on-surface mb-3">
                Improve Pronunciation
              </h3>
              <p className="font-body-md text-body-md text-on-surface-variant">
                Develop perfect Makharij (exit points) for each letter with
                tajweed-focused training.
              </p>
            </div>

            <div className="group card-pad rounded-2xl border border-outline-variant hover:border-primary hover:shadow-xl transition-all duration-300 scroll-reveal">
              <div className="w-16 h-16 bg-surface-container rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-container transition-colors">
                <Icon
                  name="menu_book"
                  className="material-symbols-outlined text-primary text-3xl group-hover:text-on-primary-container"
                />
              </div>
              <h3 className="font-headline-md text-headline-md text-on-surface mb-3">
                Prepare for Quran
              </h3>
              <p className="font-body-md text-body-md text-on-surface-variant">
                Gain the fluency required to start reading the Mushaf accurately
                and independently.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-surface-container-low">
        <div className="page-x max-w-max-width mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-16">
          <div className="flex-1">
            <img
              alt="Happy children learning"
              className="rounded-3xl shadow-lg"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuBZsU7ScAFMYQkTvZhpWdn1LUlbM6bpPVJvxUuYwkyPneXKaJK_Fme6x6Tv9J6VoOBXHuoQr795mf5puD29iPH4mz_ATj7TM5SBrLDXrXwbAK37l06R3Fu6UfEK-iW0YCPVhv82pLyqTkJMK3p_Uq-kDRlFH31_h6v-QlEqldXhkJ_gM9CsMv9I9QxF2000eC_J1v2OHGn7NEAXl5GmV2EejwS4VWC-Ds5feemuuDWSx3b9Ci55So3vsmS75ndBVWlHhjE39t6Budfs"
            />
          </div>
          <div className="flex-1 space-y-8">
            <h2 className="text-headline-responsive text-primary">
              Who is this program for?
            </h2>
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="mt-1 flex-shrink-0 w-10 h-10 rounded-full bg-tertiary-fixed flex items-center justify-center">
                  <Icon
                    name="child_care"
                    className="material-symbols-outlined text-on-tertiary-fixed"
                  />
                </div>
                <div>
                  <h4 className="font-headline-md text-headline-md text-on-surface">
                    Kids &amp; Youth
                  </h4>
                  <p className="font-body-md text-body-md text-on-surface-variant">
                    Perfect for young children (ages 4+) starting their
                    spiritual journey with engaging, interactive methods.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="mt-1 flex-shrink-0 w-10 h-10 rounded-full bg-primary-fixed flex items-center justify-center">
                  <Icon
                    name="person"
                    className="material-symbols-outlined text-on-primary-fixed"
                  />
                </div>
                <div>
                  <h4 className="font-headline-md text-headline-md text-on-surface">
                    Absolute Beginners
                  </h4>
                  <p className="font-body-md text-body-md text-on-surface-variant">
                    Adults who are new to the Arabic language and want to learn
                    to read the Quran from scratch.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="mt-1 flex-shrink-0 w-10 h-10 rounded-full bg-secondary-fixed flex items-center justify-center">
                  <Icon
                    name="refresh"
                    className="material-symbols-outlined text-on-secondary-fixed"
                  />
                </div>
                <div>
                  <h4 className="font-headline-md text-headline-md text-on-surface">
                    Re-learners
                  </h4>
                  <p className="font-body-md text-body-md text-on-surface-variant">
                    Those looking to refresh their foundation and correct basic
                    pronunciation mistakes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-white">
        <div className="page-x max-w-max-width mx-auto">
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-headline-responsive text-primary mb-4">
              What You Will Learn
            </h2>
            <p className="font-body-md text-body-md text-on-surface-variant">
              A structured curriculum designed for rapid progression.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-surface card-pad rounded-2xl border-t-4 border-tertiary-container shadow-sm hover:shadow-md transition-all">
              <span className="text-primary font-bold opacity-30 text-4xl block mb-4">
                01
              </span>
              <h3 className="font-headline-md text-headline-md text-primary mb-4">
                The Alphabet
              </h3>
              <ul className="space-y-3 font-body-md text-body-md text-on-surface-variant">
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Single Letter recognition
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Phonetic sounds (Makharij)
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Shapes in different positions
                </li>
              </ul>
            </div>

            <div className="bg-surface card-pad rounded-2xl border-t-4 border-primary shadow-sm hover:shadow-md transition-all">
              <span className="text-primary font-bold opacity-30 text-4xl block mb-4">
                02
              </span>
              <h3 className="font-headline-md text-headline-md text-primary mb-4">
                Vowels &amp; Symbols
              </h3>
              <ul className="space-y-3 font-body-md text-body-md text-on-surface-variant">
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Fatha, Kasra, Damma
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Sukoon and Shaddah
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Madd rules (Long vowels)
                </li>
              </ul>
            </div>

            <div className="bg-surface card-pad rounded-2xl border-t-4 border-secondary shadow-sm hover:shadow-md transition-all">
              <span className="text-primary font-bold opacity-30 text-4xl block mb-4">
                03
              </span>
              <h3 className="font-headline-md text-headline-md text-primary mb-4">
                Fluent Reading
              </h3>
              <ul className="space-y-3 font-body-md text-body-md text-on-surface-variant">
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Joining compound words
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Basic pause rules
                </li>
                <li className="flex items-center gap-2">
                  <Icon
                    name="check_circle"
                    className="material-symbols-outlined text-primary text-sm"
                  />{" "}
                  Intro to Quranic verses
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-surface-dim">
        <div className="page-x max-w-max-width mx-auto">
          <div className="bg-white rounded-3xl p-12 md:p-20 shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 p-8 opacity-5">
              <Icon
                name="calendar_month"
                className="material-symbols-outlined text-[150px]"
              />
            </div>
            <div className="relative z-10 flex flex-col md:flex-row gap-8 md:gap-16 items-center">
              <div className="flex-1 space-y-6">
                <h2 className="text-display-responsive text-primary">
                  Class Structure
                </h2>
                <p className="font-body-lg text-body-lg text-on-surface-variant">
                  We understand that every student is unique. Our 1-on-1
                  methodology ensures you get the full attention of our
                  certified tutors.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                      <Icon
                        name="person_search"
                        className="material-symbols-outlined text-on-primary-fixed"
                      />
                    </div>
                    <span className="font-label-md text-label-md font-bold">
                      1-on-1 Personal Tutor
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-tertiary-fixed rounded-xl flex items-center justify-center">
                      <Icon
                        name="timer"
                        className="material-symbols-outlined text-on-tertiary-fixed"
                      />
                    </div>
                    <span className="font-label-md text-label-md font-bold">
                      30 Min Sessions
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-secondary-fixed rounded-xl flex items-center justify-center">
                      <Icon
                        name="event_available"
                        className="material-symbols-outlined text-on-secondary-fixed"
                      />
                    </div>
                    <span className="font-label-md text-label-md font-bold">
                      Flexible Days/Times
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-outline-variant rounded-xl flex items-center justify-center">
                      <Icon
                        name="video_chat"
                        className="material-symbols-outlined text-on-surface-variant"
                      />
                    </div>
                    <span className="font-label-md text-label-md font-bold">
                      Live Video Classes
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 w-full md:w-80 bg-surface-container rounded-2xl p-8 space-y-6 border border-outline-variant">
                <div className="text-center">
                  <p className="font-label-md text-label-md text-on-surface-variant">
                    Starting from
                  </p>
                  <p className="text-display-responsive text-primary">
                    $45
                    <span className="text-lg font-normal text-on-surface-variant">
                      /mo
                    </span>
                  </p>
                </div>
                <div className="space-y-4">
                  <Link
                    to="/contact"
                    className="block w-full text-center bg-primary text-on-primary py-4 rounded-full font-label-md text-label-md hover:bg-primary-container transition-all"
                  >
                    Start Free Trial
                  </Link>
                  <p className="text-center font-caption text-caption text-on-surface-variant">
                    No credit card required for trial
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-32 relative">
        <div className="relative z-10 page-x max-w-max-width mx-auto text-center space-y-8">
          <h2 className="text-display-responsive text-primary">
            Begin Your Journey Today
          </h2>
          <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mx-auto">
            Join thousands of students who have mastered the Noorani Qaida with
            Online Quran Universe. Experience our teaching style first with a
            complimentary 1-on-1 session.
          </p>
          <div className="flex justify-center gap-6">
            <Link
              to="/contact"
              className="inline-block bg-primary text-on-primary px-10 py-5 rounded-full font-headline-md text-headline-md shadow-xl hover:scale-105 active:scale-95 transition-all"
            >
              Start Your Free Trial Now
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
